import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAY_URL, PDF_URL } from "../../../BaseURL";
import { useDispatch, useSelector } from 'react-redux';
import { getUserCategory } from '../../../Store/User/Category/UserCategory';
import toast from "react-hot-toast";
import Header from "../include/Header";
import Sidebar from "../include/Sidebar";

import Select from "react-select";
import { Link } from "react-router-dom";
const ManagePartyBill = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);
  const [projects, setProjects] = useState([]);
  const [parties, setParties] = useState([]);
  const data = location.state;
const [formErrors, setFormErrors] = useState({});
 const [siteOptions, setSiteOptions] = useState([]);
 const [firms, setFirms] = useState([]);

 
  //  const [categories, setCategories] = useState([]);
const dispatch = useDispatch();

const categories = useSelector((state) => state.getUserCategory?.categories || []);

console.log("categories",categories);

useEffect(() => {
    dispatch(getUserCategory());
}, [dispatch]);

const taxTypeOptions = [
  { value: "CGST/SGST", label: "CGST/SGST" },
  { value: "IGST", label: "IGST" }
];

const categoryOptions = categories.map((cat) => ({
    value: cat.name, // or cat._id if you want to save ID
    label: cat.name,
}));

// GST calculation function
const calculateGST = (amount, gstPercent, taxType) => {
  const amt = parseFloat(amount) || 0;
  const gst = parseFloat(gstPercent) || 0;
  let cgst = 0, sgst = 0, igst = 0;

  if (taxType === "CGST/SGST") {
    cgst = sgst = (amt * gst) / 100 / 2;
  } else if (taxType === "IGST") {
    igst = (amt * gst) / 100;
  }

  const totalAmount = amt + cgst + sgst + igst;
  return { cgst, sgst, igst, totalAmount };
};
const handleGSTChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => {
    const updatedData = { ...prev, [name]: value };

    // Recalculate GST when amount, GST %, or tax type changes
    if (name === "amount_without_gst" || name === "gst" || name === "tax_type") {
      const { cgst, sgst, igst, totalAmount } = calculateGST(
        updatedData.amount_without_gst,
        updatedData.gst,
        updatedData.tax_type
      );
      updatedData.cgst = cgst.toFixed(2);
      updatedData.sgst = sgst.toFixed(2);
      updatedData.igst = igst.toFixed(2);
      updatedData.amount_with_gst = totalAmount.toFixed(2);
    }

    return updatedData;
  });
};

  const [formData, setFormData] = useState({
    site: "",
    firm_id:"",
    project_id: "",
    category: "",
    party_id: "",
    invoice_no: "",
    invoice_date: "",
    amount_without_gst: "",
    gst:"",
    tax_type:"",
    cgst:"",
    sgst:"",
    igst:"",
    amount_with_gst: "",
    description: "",
    po_no: "",
    receiving_date: "",
    receiving_by: "",
    receiving_from: "",
    beneficiary_name: "",
    bank_name: "",
    account_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    mail_status: "",
    payment_status: "",
    balance_amount: "",
    file:"",
    remark: "",
  });

  // Fetch projects
  const getProjects = () => {
    axios
      .get(`${PAY_URL}/user/get-all-projects`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("PAY_ADMIN_TOKEN") },
      })
      .then((res) => {
        if (res.data.success) setProjects(res.data.data);
      })
      .catch(() => toast.error("Failed to fetch projects"));
  };

  // Fetch parties
  const getParties = () => {
    axios
      .get(`${PAY_URL}/user/get-all-parties`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("PAY_ADMIN_TOKEN") },
      })
      .then((res) => {
        if (res.data.success) setParties(res.data.data);
      })
      .catch(() => toast.error("Failed to fetch parties"));
  };
useEffect(() => {
  const fetchFirms = async () => {
    try {
      const token = localStorage.getItem("PAY_ADMIN_TOKEN");
      const res = await axios.get(`${PAY_URL}/user/get-firm-party-bill`, {
        headers: { Authorization: "Bearer " + token },
      });
      if (res.data.success) {
        setFirms(res.data.data);
      } else {
        setFirms([]);
      }
    } catch (err) {
      console.error("Error fetching firms:", err);
      setFirms([]);
    }
  };

  fetchFirms();
}, []);


useEffect(() => {
  if (!localStorage.getItem("PAY_ADMIN_TOKEN")) navigate("/admin/login");
  getProjects();
  getParties();

  if (data?._id) {
    axios
      .get(`${PAY_URL}/user/get-party-bill-by-id/${data._id}/get-party-bill-by-id`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("PAY_ADMIN_TOKEN") },
      })
      .then((res) => {
        if (res.data.success) {
          const bill = res.data.data;

          // <-- Add the GST recalculation here
          const party = bill.party_id || {};
          const firm = bill.firm_id || {};

          let initialFormData = {
            site: bill.site || "",
            firm_id: firm._id || "",
            project_id: bill.project_id?._id || "",
            category: bill.category || "",
            party_id: party._id || "",
            invoice_no: bill.invoice_no || "",
            invoice_date: bill.invoice_date ? bill.invoice_date.slice(0, 10) : "",
            amount_without_gst: bill.amount_with_out_gst || "",
            gst: bill.gst || "",
            tax_type: bill.tax_type || "",
            description: bill.description || "",
            po_no: bill.po_no || "",
            receiving_date: bill.receiving_date ? bill.receiving_date.slice(0, 10) : "",
            receiving_by: bill.receiving_by || "",
            receiving_from: bill.receiving_from || "",
            beneficiary_name: party.name || "",
            bank_name: party.bank_name || "",
            account_name: party.name || "",
            ifsc_code: party.ifsc_code || "",
            bank_acc_no: party.bank_acc_no || "",
            mail_status: bill.mail_status ? "sent" : "pending",
            payment_status: bill.payment_status ? "paid" : "pending",
            balance_amount: bill.balance_amount || "",
            file: bill.file ? `${PDF_URL}/uploads/${bill.file}` : "",
            remark: bill.remark || "",
          };

          // Recalculate GST immediately
          const { cgst, sgst, igst, totalAmount } = calculateGST(
            initialFormData.amount_without_gst,
            initialFormData.gst,
            initialFormData.tax_type
          );
          initialFormData.cgst = cgst.toFixed(2);
          initialFormData.sgst = sgst.toFixed(2);
          initialFormData.igst = igst.toFixed(2);
          initialFormData.amount_with_gst = totalAmount.toFixed(2);

          setFormData(initialFormData);
        }
      })
      .catch(() => toast.error("Failed to fetch Party Bill"));
  }
}, [data?._id, navigate]);


useEffect(() => {
  const fetchSites = async () => {
    try {
      const token = localStorage.getItem("PAY_ADMIN_TOKEN");
      const res = await axios.get(`${PAY_URL}/user/get-site-location`, {
        headers: { Authorization: "Bearer " + token },
      });

      if (res.data.success) {
        // Map for react-select
        const formatted = res.data.data.map(site => ({
          label: site.name,   // <-- adjust field if InventoryLocation uses `location_name` or `site_name`
          value: site._id,
        }));
        setSiteOptions(formatted);
      } else {
        setSiteOptions([]);
      }
    } catch (err) {
      console.error("Error fetching site list:", err);
      setSiteOptions([]);
    }
  };

  fetchSites();
}, []);



 const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const handleProjectChange = (selected) => {
    const projectId = selected ? selected.value : "";
    setFormData((prev) => ({ ...prev, project_id: projectId }));
  };

const handlePartyChange = (selected) => {
    const partyId = selected ? selected.value : "";
    setFormData((prev) => ({ ...prev, party_id: partyId }));

    const selectedParty = parties.find((p) => p._id === partyId);
    if (selectedParty) {
      setFormData((prev) => ({
        ...prev,
        beneficiary_name: selectedParty.name,
        bank_name: selectedParty.bank_name || "",
        account_name: selectedParty.name || "",
        ifsc_code: selectedParty.ifsc_code || "",
        bank_acc_no: selectedParty.bank_acc_no || "",
      }));
    }
  };

const validateForm = () => {
  const errors = {};
   if (!formData.site) errors.site = "Please select site";
  

  if (!formData.project_id) errors.project_id = "Project is required";
  if (!formData.party_id) errors.party_id = "Party is required";

  if (!formData.invoice_no) errors.invoice_no = "Invoice No is required";
  if (!formData.invoice_date) errors.invoice_date = "Invoice Date is required";

  if (!formData.receiving_date) errors.receiving_date = "Receiving Date is required";
  if (!formData.category) errors.category = "Category is required";
  if (!formData.description) errors.description = "Description is required";
  if (!formData.amount_without_gst || isNaN(formData.amount_without_gst)) errors.amount_without_gst = "Enter a valid number";
  if (!formData.gst || isNaN(formData.gst)) errors.gst = "Enter a Gst percentage";
  if (!formData.cgst || isNaN(formData.cgst)) errors.cgst = "Enter a valid number";
  if (!formData.sgst || isNaN(formData.sgst)) errors.sgst = "Enter a valid number";
  if (!formData.igst || isNaN(formData.igst)) errors.igst = "Enter a valid number";
  if (!formData.amount_with_gst || isNaN(formData.amount_with_gst)) errors.amount_with_gst = "Enter a valid number";
  if (!formData.bank_name) errors.bank_name = "Bank Name is required";
  if (!formData.bank_acc_no) errors.bank_acc_no = "Bank Account No is required";
  if (!formData.ifsc_code) errors.ifsc_code = "IFSC Code is required";
 if (!formData.tax_type) errors.tax_type = "Please Select a Tax Type";


  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

const handleSubmit = async () => {
  if (!validateForm()) return;

  const formDataToSend = new FormData();
  formDataToSend.append("site", formData.site);
  formDataToSend.append("project_id", formData.project_id);
  formDataToSend.append("category", formData.category);
  formDataToSend.append("party_id", formData.party_id);
  formDataToSend.append("firm_id", formData.firm_id);
  
  formDataToSend.append("invoice_no", formData.invoice_no);
  formDataToSend.append("invoice_date", formData.invoice_date);
  formDataToSend.append("amount_with_out_gst", formData.amount_without_gst);
  formDataToSend.append("gst", formData.gst);
  formDataToSend.append("tax_type", formData.tax_type);
  formDataToSend.append("cgst", formData.cgst);
  formDataToSend.append("sgst", formData.sgst);
  formDataToSend.append("igst", formData.igst);
  formDataToSend.append("amount_with_gst", formData.amount_with_gst);
  formDataToSend.append("description", formData.description);
  formDataToSend.append("po_no", formData.po_no);
  formDataToSend.append("receiving_date", formData.receiving_date);
  formDataToSend.append("receiving_by", formData.receiving_by);
  formDataToSend.append("receiving_from", formData.receiving_from);
  formDataToSend.append("beneficiary_name", formData.party_id);
  formDataToSend.append("bank_name", formData.bank_name);
  formDataToSend.append("account_name", formData.account_name);
  formDataToSend.append("ifsc_code", formData.ifsc_code);
  formDataToSend.append("bank_acc_no", formData.bank_acc_no);
  formDataToSend.append("mail_status", formData.mail_status === "sent");
  formDataToSend.append("payment_status", formData.payment_status === "paid");
  formDataToSend.append("balance_amount", formData.balance_amount);
  formDataToSend.append("remark", formData.remark);

  if (formData.file && typeof formData.file !== "string") {
    formDataToSend.append("file", formData.file); // important: field name must be "file"
  }

  const token = localStorage.getItem("PAY_ADMIN_TOKEN");

  try {
    let res;
    if (data?._id) {
      res = await axios.put(
        `${PAY_URL}/user/update-party-bill/${data._id}/update-party-bill`,
        formDataToSend,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      res = await axios.post(
        `${PAY_URL}/admin/manage-party-bill`,
        formDataToSend,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    if (res.data.success) {
      toast.success(data?._id ? "Party bill updated" : "Party bill created");
      navigate("/admin/party-bill-management");
    } else {
      toast.error(res.data.message || "Failed to save");
    }
  } catch (err) {
    toast.error("Server error");
  }
};

  
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">

          <div className="page-header">
                                  <div className="row align-items-center">
                                      <div className="col">
                                          <h3 className="page-title admin-title">Party Bill Management</h3>
                                          <ul className="breadcrumb">
                                              <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                               <li className="breadcrumb-item"><Link to='/user/party-bill'>Party Bill Management</Link></li>
                                              <li className="breadcrumb-item active">Add Party Bill</li>
                                          </ul>

                                          
                                      </div>
                                     
                                  </div>
                              </div>
          <div className="card p-3 basicform">
  <div className="row">
    {/* Site */}
  
<div className="col-md-4">
  <label>Site <span className="text-danger">*</span></label>
  <Select
    name="site"
    value={
      formData.site
        ? siteOptions.find(option => option.value === formData.site)
        : null
    }
    options={siteOptions}
    onChange={(selected) => {
      setFormData({ ...formData, site: selected.value });
      if (formErrors.site) setFormErrors(prev => ({ ...prev, site: '' }));
    }}
  />
  {formErrors.site && <div className="invalid-feedback d-block">{formErrors.site}</div>}
</div>

    {/* Project */}
    <div className="col-md-4">
      <label>Project <span className="text-danger">*</span></label>
      <Select
        name="project_id"
        value={
          projects.find((p) => p._id === formData.project_id)
            ? { value: formData.project_id, label: projects.find((p) => p._id === formData.project_id).name }
            : null
        }
        options={projects.map((p) => ({ value: p._id, label: p.name }))}
        onChange={(selected) => {
          handleProjectChange(selected);
          if (formErrors.project_id) setFormErrors(prev => ({ ...prev, project_id: '' }));
        }}
        placeholder="Select or search project..."
        isSearchable
      />
      {formErrors.project_id && <div className="invalid-feedback d-block">{formErrors.project_id}</div>}
    </div>

    {/* Party */}
    <div className="col-md-4">
      <label>Party <span className="text-danger">*</span></label>
      <Select
        name="party_id"
        value={
          parties.find((p) => p._id === formData.party_id)
            ? { value: formData.party_id, label: parties.find((p) => p._id === formData.party_id).name }
            : null
        }
        options={parties.map((p) => ({ value: p._id, label: p.name }))}
        onChange={(selected) => {
          handlePartyChange(selected);
          if (formErrors.party_id) setFormErrors(prev => ({ ...prev, party_id: '' }));
        }}
        placeholder="Select or search party..."
        isSearchable
      />
      {formErrors.party_id && <div className="invalid-feedback d-block">{formErrors.party_id}</div>}
    </div>

    {/* Invoice No */}
    <div className="col-md-4">
      <label>Invoice No <span className="text-danger">*</span></label>
      <input
        type="text"
        className={`form-control ${formErrors.invoice_no ? 'is-invalid' : ''}`}
        name="invoice_no"
        value={formData.invoice_no}
        onChange={(e) => {
          setFormData({ ...formData, invoice_no: e.target.value });
          if (formErrors.invoice_no) setFormErrors(prev => ({ ...prev, invoice_no: '' }));
        }}
      />
      {formErrors.invoice_no && <div className="invalid-feedback">{formErrors.invoice_no}</div>}
    </div>

    {/* Invoice Date */}
    <div className="col-md-4">
      <label>Invoice Date <span className="text-danger">*</span></label>
      <input
        type="date"
        className={`form-control ${formErrors.invoice_date ? 'is-invalid' : ''}`}
        name="invoice_date"
        value={formData.invoice_date}
        onChange={(e) => {
          setFormData({ ...formData, invoice_date: e.target.value });
          if (formErrors.invoice_date) setFormErrors(prev => ({ ...prev, invoice_date: '' }));
        }}
      />
      {formErrors.invoice_date && <div className="invalid-feedback">{formErrors.invoice_date}</div>}
    </div>

    {/* Amount Without GST */}
    <div className="col-md-4">
      <label>Amount Without GST <span className="text-danger">*</span></label>
      {/* <input
        type="number"
        className={`form-control ${formErrors.amount_without_gst ? 'is-invalid' : ''}`}
        name="amount_without_gst"
        value={formData.amount_without_gst}
        onChange={(e) => {
          setFormData({ ...formData, amount_without_gst: e.target.value });
          if (formErrors.amount_without_gst) setFormErrors(prev => ({ ...prev, amount_without_gst: '' }));
        }}
      /> */}

      <input
  type="number"
  className={`form-control ${formErrors.amount_without_gst ? 'is-invalid' : ''}`}
  name="amount_without_gst"
  value={formData.amount_without_gst}
  onChange={(e) => {
    handleGSTChange(e); // <-- recalc GST
    if (formErrors.amount_without_gst) setFormErrors(prev => ({ ...prev, amount_without_gst: '' }));
  }}
/>

      {formErrors.amount_without_gst && <div className="invalid-feedback">{formErrors.amount_without_gst}</div>}
    </div>




    {/* Tax Type */}
<div className="col-md-4">
  <label>Tax Type<span className="text-danger">*</span></label>
  <Select
    name="tax_type"
    value={taxTypeOptions.find(option => option.value === formData.tax_type) || null}
    options={taxTypeOptions}
    onChange={(selected) => handleGSTChange({ target: { name: "tax_type", value: selected ? selected.value : "" } })}
    placeholder="Select Tax Type..."
    isSearchable
  />
  {formErrors.tax_type && <div className="invalid-feedback d-block">{formErrors.tax_type}</div>}
</div>

    {/* GST % */}
<div className="col-md-4">
  <label>GST % <span className="text-danger">*</span></label>
  <input
    type="number"
    className="form-control"
    name="gst"
    value={formData.gst}
    onChange={handleGSTChange}
    //onChange={(selected) => handleGSTChange({ target: { name: "gst", value: selected ? selected.value : "" } })}
  />
  {formErrors.gst && <div className="invalid-feedback d-block">{formErrors.gst}</div>}
</div>

{/* CGST */}
<div className="col-md-4">
  <label>CGST</label>
  <input
    type="number"
    className="form-control"
    name="cgst"
    value={formData.cgst}
    disabled={formData.tax_type === "IGST"}
    readOnly
  />
</div>

{/* SGST */}
<div className="col-md-4">
  <label>SGST</label>
  <input
    type="number"
    className="form-control"
    name="sgst"
    value={formData.sgst}
    disabled={formData.tax_type === "IGST"}
    readOnly
  />
</div>

{/* IGST */}
<div className="col-md-4">
  <label>IGST</label>
  <input
    type="number"
    className="form-control"
    name="igst"
    value={formData.igst}
    disabled={formData.tax_type === "CGST/SGST"}
    readOnly
  />
</div>

{/* Amount With GST */}
<div className="col-md-4">
  <label>Amount With GST</label>
  <input
    type="number"
    className="form-control"
    name="amount_with_gst"
    value={formData.amount_with_gst}
    readOnly
  />
</div>

    {/* Category */}
   <div className="col-md-4">
  <label>Category <span className="text-danger">*</span></label>
  <Select
    name="category"
    value={formData.category ? categoryOptions.find(opt => opt.value === formData.category) : null}
    options={categoryOptions}
    onChange={(selected) => {
      setFormData({ ...formData, category: selected ? selected.value : "" });
      if (formErrors.category) setFormErrors(prev => ({ ...prev, category: '' }));
    }}
    placeholder="Select or search category..."
    isSearchable
  />
  {formErrors.category && <div className="invalid-feedback d-block">{formErrors.category}</div>}
</div>


    {/* Description */}
    <div className="col-md-12">
      <label>Description <span className="text-danger">*</span></label>
      <textarea
        className={`form-control ${formErrors.description ? 'is-invalid' : ''}`}
        name="description"
        value={formData.description}
        onChange={(e) => {
          setFormData({ ...formData, description: e.target.value });
          if (formErrors.description) setFormErrors(prev => ({ ...prev, description: '' }));
        }}
      />
      {formErrors.description && <div className="invalid-feedback">{formErrors.description}</div>}
    </div>

    {/* PO No */}
 <div className="col-md-4">
                <label>PO No</label>
                <input
                  type="text"
                  className="form-control"
                  name="po_no"
                  value={formData.po_no}
                  onChange={handleChange}
                />
              </div>


{/* Firm */}
<div className="col-md-4">
  <label>Firm </label>
  <Select
    name="firm_id"
    value={formData.firm_id ? firms.find(f => f._id === formData.firm_id) && { value: formData.firm_id, label: firms.find(f => f._id === formData.firm_id).name } : null}
    options={firms.map(f => ({ value: f._id, label: f.name }))}
    onChange={(selected) => setFormData(prev => ({ ...prev, firm_id: selected ? selected.value : "" }))}
    placeholder="Select or search firm..."
    isSearchable
  />
  {formErrors.firm_id && <div className="invalid-feedback d-block">{formErrors.firm_id}</div>}
</div>

    {/* Receiving Date */}
    <div className="col-md-4">
      <label>Receiving Date <span className="text-danger">*</span></label>
      <input
        type="date"
        className={`form-control ${formErrors.receiving_date ? 'is-invalid' : ''}`}
        name="receiving_date"
        value={formData.receiving_date}
        onChange={(e) => {
          setFormData({ ...formData, receiving_date: e.target.value });
          if (formErrors.receiving_date) setFormErrors(prev => ({ ...prev, receiving_date: '' }));
        }}
      />
      {formErrors.receiving_date && <div className="invalid-feedback">{formErrors.receiving_date}</div>}
    </div>

    {/* Receiving By */}
    <div className="col-md-4">
      <label>Receiving By</label>
      <input
        type="text"
        className="form-control"
        name="receiving_by"
        value={formData.receiving_by}
        onChange={handleChange}
      />
    
    </div>

    {/* Received From */}
    <div className="col-md-4">
      <label>Received From</label>
      <input
        type="text"
         className="form-control"
        name="receiving_from"
        value={formData.receiving_from}
        onChange={handleChange}
      />
     
    </div>

    {/* Beneficiary Name */}
{/* Beneficiary Name */}
<div className="col-md-4">
  <label>Beneficiary Name <span className="text-danger">*</span></label>
  <input
    type="text"
    className={`form-control ${formErrors.beneficiary_name ? 'is-invalid' : ''}`}
    name="beneficiary_name"
    value={formData.beneficiary_name}
    onChange={(e) => {
      setFormData({ ...formData, beneficiary_name: e.target.value });
      if (formErrors.beneficiary_name) setFormErrors(prev => ({ ...prev, beneficiary_name: '' }));
    }}
    readOnly
  />
  {formErrors.beneficiary_name && (
    <div className="invalid-feedback">{formErrors.beneficiary_name}</div>
  )}
</div>


    {/* Bank Name */}
    <div className="col-md-4">
      <label>Bank Name</label>
      <input
        type="text"
        className={`form-control ${formErrors.bank_name ? 'is-invalid' : ''}`}
        name="bank_name"
        value={formData.bank_name}
        onChange={(e) => {
          setFormData({ ...formData, bank_name: e.target.value });
          if (formErrors.bank_name) setFormErrors(prev => ({ ...prev, bank_name: '' }));
        }}
      />
      {formErrors.bank_name && <div className="invalid-feedback">{formErrors.bank_name}</div>}
    </div>

    {/* Account Number */}
    <div className="col-md-4">
      <label>Account Number</label>
      <input
        type="text"
        className={`form-control ${formErrors.bank_acc_no ? 'is-invalid' : ''}`}
        name="bank_acc_no"
        value={formData.bank_acc_no}
        onChange={(e) => {
          setFormData({ ...formData, bank_acc_no: e.target.value });
          if (formErrors.bank_acc_no) setFormErrors(prev => ({ ...prev, bank_acc_no: '' }));
        }}
      />
      {formErrors.bank_acc_no && <div className="invalid-feedback">{formErrors.bank_acc_no}</div>}
    </div>

    {/* IFSC Code */}
    <div className="col-md-4">
      <label>IFSC Code</label>
      <input
        type="text"
        className={`form-control ${formErrors.ifsc_code ? 'is-invalid' : ''}`}
        name="ifsc_code"
        value={formData.ifsc_code}
        onChange={(e) => {
          setFormData({ ...formData, ifsc_code: e.target.value });
          if (formErrors.ifsc_code) setFormErrors(prev => ({ ...prev, ifsc_code: '' }));
        }}
      />
      {formErrors.ifsc_code && <div className="invalid-feedback">{formErrors.ifsc_code}</div>}
    </div>

    {/* Mail Status */}
    <div className="col-md-4">
      <label>Mail Status </label>
      <select
        className={`form-select ${formErrors.mail_status ? 'is-invalid' : ''}`}
        name="mail_status"
        value={formData.mail_status}
        onChange={(e) => {
          setFormData({ ...formData, mail_status: e.target.value });
          if (formErrors.mail_status) setFormErrors(prev => ({ ...prev, mail_status: '' }));
        }}
      >
        <option value="">Select</option>
        <option value="sent">Sent</option>
        <option value="pending">Pending</option>
      </select>
      {formErrors.mail_status && <div className="invalid-feedback">{formErrors.mail_status}</div>}
    </div>

    {/* Payment Status */}
    <div className="col-md-4">
      <label>Payment Status</label>
      <select
        className={`form-select ${formErrors.payment_status ? 'is-invalid' : ''}`}
        name="payment_status"
        value={formData.payment_status}
        onChange={(e) => {
          setFormData({ ...formData, payment_status: e.target.value });
          if (formErrors.payment_status) setFormErrors(prev => ({ ...prev, payment_status: '' }));
        }}
      >
        <option value="">Select</option>
        <option value="paid">Paid</option>
        <option value="pending">Pending</option>
      </select>
      {formErrors.payment_status && <div className="invalid-feedback">{formErrors.payment_status}</div>}
    </div>

    {/* Balance Amount */}
    <div className="col-md-4">
      <label>Balance Amount</label>
      <input
        type="number"
        className={`form-control ${formErrors.balance_amount ? 'is-invalid' : ''}`}
        name="balance_amount"
        value={formData.balance_amount}
        onChange={(e) => {
          setFormData({ ...formData, balance_amount: e.target.value });
          if (formErrors.balance_amount) setFormErrors(prev => ({ ...prev, balance_amount: '' }));
        }}
      />
      {formErrors.balance_amount && <div className="invalid-feedback">{formErrors.balance_amount}</div>}
    </div>

    {/* File Upload */}
    <div className="col-md-4">
      <label>File Upload</label>
      <input
        type="file"
        className={`form-control ${formErrors.file ? 'is-invalid' : ''}`}
        name="file"
        accept="application/pdf"
        onChange={(e) => {
          setFormData({ ...formData, file: e.target.files[0] });
          if (formErrors.file) setFormErrors(prev => ({ ...prev, file: '' }));
        }}
      />
      {formErrors.file && <div className="invalid-feedback">{formErrors.file}</div>}

      {/* Existing file preview */}
      {formData.file && typeof formData.file === "string" && (
        <div className="mt-2">
          <a href={formData.file} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <i className="fa fa-file-pdf-o" style={{ fontSize: "20px", color: "red" }}></i>
            <span>{formData.file.split("/").pop()}</span>
          </a>
        </div>
      )}

      {/* New file preview */}
      {formData.file && typeof formData.file !== "string" && (
        <div className="mt-2">
          <i className="fa fa-file-pdf-o" style={{ fontSize: "20px", color: "red" }}></i>{" "}
          <span>{formData.file.name}</span>
        </div>
      )}
    </div>

    {/* Remarks */}
    <div className="col-md-12">
      <label>Remarks</label>
      <textarea
        className={`form-control ${formErrors.remark ? 'is-invalid' : ''}`}
        name="remark"
        value={formData.remark}
        onChange={(e) => {
          setFormData({ ...formData, remark: e.target.value });
          if (formErrors.remark) setFormErrors(prev => ({ ...prev, remark: '' }));
        }}
      />
      {formErrors.remark && <div className="invalid-feedback">{formErrors.remark}</div>}
    </div>
  </div>

  <div className="mt-3">
    <button
      className="btn btn-success"
      type="button"
      disabled={disable}
      onClick={handleSubmit}
    >
      {disable ? "Processing..." : data?._id ? "Update" : "Submit"}
    </button>
    <button
      className="btn btn-outline-secondary ms-2"
      type="button"
      onClick={() => setFormData({})}
    >
      Reset
    </button>
  </div>
</div>

        </div>
        
      </div>
    </div>
  );
};

export default ManagePartyBill;
